import { render, staticRenderFns } from "./report-templates.vue?vue&type=template&id=4b447daf&scoped=true&"
import script from "./report-templates.vue?vue&type=script&lang=js&"
export * from "./report-templates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b447daf",
  null
  
)

export default component.exports